import { Endpoints } from '@/remote/endpoints'
import { Button } from '@/view/components/ui/button'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from '@/view/components/ui/dropdown-menu'
import { Eye, MoreHorizontal, Trash2, UserPen } from 'lucide-react'
import { useState } from 'react'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/table'
import { DialogCreateGroups } from '../modals/modal-create-group'
import { DialogDelete } from '../modals/modal-delete'
import { DialogDetailGroups } from '../modals/modal-detail-groups'
import { DialogEditGroups } from '../modals/modal-edit-groups'
import { GroupsFormData } from '../validators/groups-validator'
import { ScrollArea } from './ui/scroll-area'

type TableGropsProps = {
  data: GroupsFormData[]
  height?: string
  getRefreshList?: () => void
}

type ModalState = {
  type: 'create' | 'edit' | 'delete' | 'detail' | null
  isOpen: boolean
  dataId?: number
}

export function TableGroups({ data, height, getRefreshList }: TableGropsProps) {
  const [modalState, setModalState] = useState<ModalState>({
    type: null,
    isOpen: false,
    dataId: undefined
  })

  const handleOpenModal = (type: ModalState['type'], dataId?: number) => {
    setModalState({
      type,
      isOpen: true,
      dataId
    })
  }

  const handleCloseModal = () => {
    setModalState({
      type: null,
      isOpen: false,
      dataId: undefined
    })
  }

  const renderModal = () => {
    switch (modalState.type) {
      case 'create':
        return <DialogCreateGroups closeDialog={handleCloseModal} isOpen={modalState.isOpen} updateList={getRefreshList} />
      case 'edit':
        return <DialogEditGroups updateList={getRefreshList} closeDialog={handleCloseModal} id={modalState.dataId!} isOpen={modalState.isOpen} />
      case 'delete':
        return (
          <DialogDelete
            updateList={getRefreshList}
            closeDialog={handleCloseModal}
            id={modalState.dataId!}
            isOpen={modalState.isOpen}
            url={Endpoints.gruops}
            label="Grupos Muscular"
            unidade="idUnidade"
          />
        )
      case 'detail':
        return <DialogDetailGroups id={modalState.dataId!} closeDialog={handleCloseModal} isOpen={modalState.isOpen} />
      default:
        return null
    }
  }

  return (
    <div className={'overflow-y-auto' + height}>
      {renderModal()}
      <ScrollArea className="m-4 h-container-members-list relative mt-0">
        {/* <div className="flex justify-end mb-2">
          <button
            onClick={() => handleOpenModal('create')}
            className="flex items-center gap-2 bg-acelerafit-green-400 hover:bg-cashfit-green-200 text-muted px-2 py-2 rounded-md transition-colors"
          >
            <Plus className="w-5 h-5" />
            Adicionar Grupo
          </button>
        </div> */}
        <Table className="border-none">
          <TableHeader>
            <TableRow>
              <TableHead>ID</TableHead>
              <TableHead>Nome</TableHead>
              <TableHead>Descrição</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.map((groups: GroupsFormData, position: number) => (
              <TableRow key={position} className="text-gray-600">
                <TableCell>{groups?.id || 'Sem Id'}</TableCell>
                <TableCell className="flex gap-2 capitalize cursor-pointer text-acelerafit-gray-dark hover:text-cashfit-green-200" onClick={() => handleOpenModal('detail', groups?.id)}>
                  {groups.nome}
                </TableCell>
                <TableCell>{groups?.descricao}</TableCell>
                <TableCell>
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button variant="ghost" className="h-8 w-8 p-0">
                        <span className="sr-only">Abrir Menu</span>
                        <MoreHorizontal className="h-4 w-4" />
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="center">
                      <DropdownMenuLabel>Ações</DropdownMenuLabel>
                      <DropdownMenuItem className="flex gap-2 cursor-pointer" onClick={() => handleOpenModal('detail', groups?.id)}>
                        <Eye height={24} width={30} className="text-blue-500 cursor-pointer p-1 hover:text-blue-400" />
                        Detalhes
                      </DropdownMenuItem>
                      <DropdownMenuSeparator />
                      <DropdownMenuItem className="flex gap-2 cursor-pointer" onClick={() => handleOpenModal('edit', groups?.id)}>
                        <UserPen height={24} width={30} className="text-blue-500 cursor-pointer p-1 hover:text-blue-400" />
                        Editar
                      </DropdownMenuItem>
                      <DropdownMenuSeparator />
                      <DropdownMenuItem className="flex gap-2 cursor-pointer" onClick={() => handleOpenModal('delete', groups?.id)}>
                        <Trash2 height={24} width={30} className="text-red-500 cursor-pointer p-1 hover:text-red-400" />
                        Apagar
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </ScrollArea>
    </div>
  )
}
